const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');
/**
 * Overview Reports Controller
 * @argument {Service} Application Application injected to gain access to the global Application functions and properties
 * @argument {Resource} ReportsService Report Service API resource
 * @argument {Resource} CustomReportQueryService API service resource for managing custom report queries
 * @argument {Service} ReportsData service for retrieving hardcoded report data
 * @argument {Resource} Users Users Resource to manage user's search queries
 * @argument {Service} AccessHelper Profiles access util to check area access
 * @argument {$window} $window Angular's window wrapper
 * @argument {$translate} $translate Translation service wrapper
 */
app.controller('overviewReports', ['Application', 'Authorization', 'ReportsService', 'CustomReportQueryService', 'ReportsData', 'Companies', 'Users', 'AccessHelper', '$window', '$translate', '$timeout', '$scope', function(Application, Authorization, ReportsService, CustomReportQueryService, ReportsData, Companies, Users, AccessHelper, $window, $translate, $timeout, $scope) {
  var self = this;
  self.allowance = {
    reports: AccessHelper.isAllowed(['admin', 'reports'], null, ['admin'])
  };

  if (!self.allowance.reports || Application.access.role !== 'admin') {
    Application.navigation.goTo('/explore');
    return;
  }
  self.showChooseAtLeastOneTrack = false;
  self.showChooseAtLeastOneContent = false;
  self.loading = false;
  self.translations = {};
  self.warning_no_data = false;
  self.toDelete = null;
  self.allReports = {};
  self.myReportList = [];
  self.searchQuery = '';
  self.searchActive = false;
  self.searchDelayTimer = null;
  self.activeTab = 'myreports'; //on init
  self.start_date = moment().subtract(1, 'year').toDate();
  self.end_date = moment().toDate();
  self.start_of_last_year = moment().subtract(1, 'year').startOf('year').toDate();
  self.end_of_last_year = moment().subtract(1, 'year').endOf('year').toDate();

  self.paginate = {
    myReports: {
      pageNumber: 1,
      total: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
    customReports: {
      pageNumber: 1,
      total: 0,
      hasNextPage: false,
      hasPrevPage: false,
    }
  }

  self.changePage = function(pageTurnAmount, reportsCategory) {
    var page = reportsCategory;
    self.paginate[page].pageNumber += pageTurnAmount;

    if (self.searchActive) {
      self.searchReports(self.paginate[page].pageNumber);
    } else {
      if (page === 'customReports') {
        self.initializeCustomReports(self.paginate[page].pageNumber);
      } else {
        self.initializeMyReports(self.paginate[page].pageNumber, Authorization.getAuthToken().user._id)
      }
    }
  }

  self.dateFormatString = 'yyyy/MM/dd'

  self.changeRoute = function(r){
    if(!r){
      return;
    }
    Application.navigation.goTo(r);
  };

  self.isToday = function(date) {
    var dates = {
      "incoming": moment(date).format('YYYY/MM/DD'),
      "today": moment().format('YYYY/MM/DD')
    };
    if (dates.incoming === dates.today) {
      return moment(date).subtract(1, 'days').format('YYYY/MM/DD');
    }

    return dates.incoming;
  };
  self.arguments = {
    today: moment().format('YYYY/MM/DD'),
    yesterday: moment().subtract(1, 'days').format('YYYY/MM/DD'),
    from_date: moment().format('YYYY/MM/DD'),
    until_date: moment().format('YYYY/MM/DD'),
    date_range_days: function() {
      return moment(self.arguments.until_date, 'YYYY/MM/DD').diff(moment(self.arguments.from_date, 'YYYY/MM/DD'), 'days');
    },
    past_days: '7',
    users: '',
    placeholder: self.translations['precooked.search_by'],
    types: ['articles', 'videos', 'files', 'tracks', 'scorm', 'workshops', 'users', 'categories'],
    clear: false,
    query: {
      locations: [],
      departments: [],
      teams: [],
      org_levels: [],
      grades: [],
      tracks: [],
      content: [],
      users: []
    },
    restrictions: {},
    onQuery: function(query_arguments) {
      self.searching = false;
      self.arguments.query = query_arguments;
    }
  };

  self.searchDebounce = function(func, delay) {
    if(self.searchDelayTimer) {
      $timeout.cancel(self.searchDelayTimer);
    }
    self.searchDelayTimer = $timeout(func, delay);
  }

  self.searchReports = function(page) {
    if (!page) {
      self.paginate.myReports.pageNumber = 1;
      self.paginate.customReports.pageNumber = 1;
    }
    self.searchActive = true;
    self.searchQuery = self.searchValue;
    var reportsToSearch = '';
    var queryForSearch = {page: page || 1, search: {name: self.searchQuery}};

    if (self.activeTab === 'custom') {
      reportsToSearch = 'customReports';
    }
    if (self.activeTab === 'myreports') {
      queryForSearch.created_by = Authorization.getAuthToken().user._id;
      reportsToSearch = 'myReports';
    }
    self.getReports(queryForSearch, reportsToSearch);

    if (self.searchQuery.length === 0) {
      self.clearSearch();
    }
  };

  self.clearSearch = function() {
    self.searchActive = false;
    self.searchQuery = '';
    self.searchValue = '';
    self.paginate.myReports.pageNumber = 1;
    self.paginate.customReports.pageNumber = 1;
    self.initializeMyReports(1, Authorization.getAuthToken().user._id);
    self.initializeCustomReports();
  };

  function getCsv(reportType, results, fields) {
    var resultsTransform = ReportsData.reportTypes[reportType].resultsTransform;
    if (resultsTransform) {
      results = resultsTransform(results);
    }
    var csv = [];
    for (var i = 0, leni = results.length; i < leni; i++) {
      var row = '';
      fields.forEach(function (field) {
        var defaultValue = field.isList ? [] : '';
        var defaultForField = field.defaultValue !== undefined ? field.defaultValue : defaultValue
        var result = results[i][field.reportsServiceResponseKey || field.key];
        if (result && field.reportsServiceArrayIndex !== undefined) {
          result = result[field.reportsServiceArrayIndex];
        }

        if (result === undefined || result === null || result === "") {
          result = defaultForField;
        }
        if (field.formatter) {
          result = field.formatter(result);
        }
        if (field.quote) {
          //escape double quotes (https://en.wikipedia.org/wiki/Comma-separated_values#Example) and wrap in double quotes
          result = result ? '"' + result.replace(/"/g, '""') + '"' : "";
        }
        row += result;
        row += ','
      });
      csv.push(row.slice(0, -1)); //remove last comma
    }
    var headers = fields.map(function (field) {
      return field.name
    });
    csv.unshift(headers.join(',')); // add header column
    csv = csv.join('\n');
    return csv;
  }

  function getStandardCsv(results, reportType) {
    return getCsv(reportType, results, ReportsData.reportTypes[reportType].defaultFields);
  }

  self.duplicateReport = function(report) {
    CustomReportQueryService.duplicate({subresource: report.key}, {}).$promise
      .then(function() {
        self.editMenu.closeHandler();
        self.initializeCustomReports();
        Application.messaging.addMessage({type: 'success', text: 'Successfully duplicated report', duration: 7});
      });
  }

  self.deleteReport = function() {
    CustomReportQueryService.remove({subresource: self.toDelete.key}).$promise
      .then(function() {
        self.editMenu.closeHandler();
        function removeReportFromList(list) {
          for (var i = 0; i < list.length; i++) {
            if (list[i].key === self.toDelete.key) {
              list.splice(i, 1);
              break;
            }
          }
        }
        removeReportFromList(self.myReportList);
        removeReportFromList(self.customReportList);
        Application.analyticsProvider.trackEvent('report_deleted', {content: self.toDelete.name, content_type: self.toDelete.reportType});
        delete self.allReports[self.toDelete.key];
        self.toDelete = null;
        Application.messaging.addMessage({type: 'success', text: 'Successfully deleted report', duration: 7});
      });
  }

  self.cancelDelete = function() {
    self.editMenu.closeHandler();
    self.toDelete = null;
  }

  self.getReports = function(query, reportsCategory) {
    self.customReportList = [];
    self.myReportList = [];
    if (Authorization.getAuthToken() && Authorization.getAuthToken().company && Authorization.getAuthToken().company.createdAt) {
      self.start_date = new Date(Authorization.getAuthToken().company.createdAt);
    }
    return CustomReportQueryService.find(query).$promise.then(function (results) {
      results.docs.forEach(function (result) {
        const reportData = ReportsData.reportTypes[result.report_type];
        const fields = result.report_fields.reduce(function(allowedFields, fieldKey) {
          if (reportData.reportFieldsByKey[fieldKey]) {
            allowedFields.push(reportData.reportFieldsByKey[fieldKey]);
          }
          return allowedFields;
        }, []);
        const customReport = {
          key: result._id,
          name: result.name,
          report_type: result.report_type,
          created_by_name: result.created_by_name,
          first_date: self.start_date,
          last_date: self.end_date,
          start_of_last_year: self.start_of_last_year,
          end_of_last_year: self.end_of_last_year,
          fields: fields.map(function (field) {
            return field.reportsServiceRequestKey || field.key
          }),
          filters: result.report_filters || [],
          options: result.report_options,
          isStandard: false,
          applyDateRange: reportData.applyDateRange,
          csv: function (csv_results) {
            return getCsv(result.report_type, csv_results, fields)
          }
        };
        if (reportsCategory === 'myReports') {
          self.myReportList.push(customReport);
        }
        if (reportsCategory === 'customReports') {
          self.customReportList.push(customReport);
        }
        self.allReports[result._id] = customReport;
      });

      self.paginate[reportsCategory].hasNextPage = results.hasNextPage;
      self.paginate[reportsCategory].hasPrevPage = results.hasPrevPage;
      self.paginate[reportsCategory].total = results.totalDocs;
    })
      .catch(function(err) {
        console.error(err);
      });
  }

  //initialize My Reports
  self.initializeMyReports = function(page, userId) {
    const query = {created_by: userId, page: page || 1};
    self.getReports(query, 'myReports');
  }

  // initialize Custom (Saved) Reports
  self.initializeCustomReports = function(page) {
    const query = {page: page || 1};
    self.getReports(query, 'customReports');
  }

  self.initializeStandardReports = function() {
    const standardReportList = [];

    if (Authorization.getAuthToken() && Authorization.getAuthToken().company && Authorization.getAuthToken().company.createdAt) {
      self.start_date = new Date(Authorization.getAuthToken().company.createdAt);
    }

    Object.keys(ReportsData.reportTypes).forEach(function (key) {
      const reportData = ReportsData.reportTypes[key];
      const report = {
        key: key,
        name: reportData.name,
        report_type: key,
        first_date: self.start_date,
        last_date: self.end_date,
        start_of_last_year: self.start_of_last_year,
        end_of_last_year: self.end_of_last_year,
        fields: reportData.defaultFields.map(function (field) {
          return field.reportsServiceRequestKey || field.key
        }),
        filters: [],
        isStandard: true,
        applyDateRange: reportData.applyDateRange,
        csv: function (results) {
          return getStandardCsv(results, key)
        }
      };
      standardReportList.push(report);
      self.allReports[key] = report;
    });
    self.report_list = standardReportList;
  }

  self.initialize = function() {
    if (!Application.features.flags().reports) {
      Application.navigation.goToHome();
      return;
    }

    self.initializeMyReports(1, Authorization.getAuthToken().user._id);
    self.initializeCustomReports();
    self.initializeStandardReports();
    self.last_date = self.report_list[0].first_date;
  };

    self.getUntilDate = function(key) {
      if (self.arguments.past_days === '110') {
        return moment(self.arguments.until_date, 'YYYY/MM/DD').toDate();
      }
      if (self.arguments.past_days === '120') {
        return self.allReports[key].end_of_last_year;
      }
      return self.allReports[key].last_date;
    };
    self.getFromDate = function(key) {
      if (self.arguments.past_days === '100') {
        return self.allReports[key].first_date;
      }
      if (self.arguments.past_days === '110') {
        return moment(self.arguments.from_date, 'YYYY/MM/DD').toDate();
      }
      if (self.arguments.past_days === '120') {
        return self.allReports[key].start_of_last_year;
      }
      return moment(self.allReports[key].last_date).subtract(parseInt(self.arguments.past_days), 'day').toDate();
    };
    self.csvReport = function(report_key) {
      self.loading = true;
      self.editMenu.closeHandler();
      //:report/:year/:month/:day
      var report_config = self.allReports[report_key];
      const report_type = report_config.report_type;
      var fd = moment().subtract(parseInt(self.arguments.past_days), 'day');
      var ud = moment();
      if (self.arguments.past_days === '100') {
        fd = moment(report_config.first_date);
      }
      if (self.arguments.past_days === '120') {
        fd = moment(report_config.start_of_last_year);
        ud = moment(report_config.end_of_last_year);
      }
      if (self.arguments.past_days === '110') {
        if (self.arguments.date_range_days() === 0) {
          Application.messaging.addMessage({type: 'error', text: self.translations['precooked.date_range_same'], duration: 5});
          self.loading = false;
          return;
        }
        fd = moment(self.arguments.from_date, 'YYYY/MM/DD');
        ud = moment(self.arguments.until_date, 'YYYY/MM/DD');
      }

      const reportTypeConfig = ReportsData.reportTypes[report_config.report_type];
      const report_request = JSON.parse(JSON.stringify(reportTypeConfig.defaultFilters));

      report_config.fields.forEach(function (report_field) {
        report_request[report_field] = true;
      });
      report_config.filters.forEach(function(reportFilter) {
        const filterConfig = reportTypeConfig.filterTypeToReportFilterConfig[reportFilter.value_sub_type || reportFilter.value_type];
        if (!(filterConfig.reportsGroup in report_request)) {
          report_request[filterConfig.reportsGroup] = {};
        }
        if (!(filterConfig.reportsGroupKey in report_request[filterConfig.reportsGroup])) {
          report_request[filterConfig.reportsGroup][filterConfig.reportsGroupKey] = '';
        }
        if (report_request[filterConfig.reportsGroup][filterConfig.reportsGroupKey].length !== 0) {
          report_request[filterConfig.reportsGroup][filterConfig.reportsGroupKey] += ','
        }
        report_request[filterConfig.reportsGroup][filterConfig.reportsGroupKey] += reportFilter.value.join(',');
      });
      if (!report_config.isStandard) {
        if (report_request.user_filter?.hasOwnProperty("suspended") && report_config.options.hasOwnProperty("includeSuspendedUsers")) {
          report_request.user_filter.suspended = report_config.options.includeSuspendedUsers ? '' : 'false';
        }
      }
      if (report_config.isStandard) {
        if (self.arguments.query.users && self.arguments.query.users.length) {
          if (report_request.user_filter) {
            report_request.user_filter.id = self.arguments.query.users.join(',');
          }
          if (report_request.manager_filter) {
            report_request.manager_filter.id = self.arguments.query.users.join(',');
          }
        }
        if (self.arguments.query.locations && self.arguments.query.locations.length) {
          if (report_request.user_filter) {
            report_request.user_filter.locations = self.arguments.query.locations.join(',');
          }
          if (report_request.manager_filter) {
            report_request.manager_filter.locations = self.arguments.query.locations.join(',');
          }
          if (report_request.content_filter) {
            report_request.content_filter.locations = self.arguments.query.locations.join(',');
          }
          if (report_request.track_filter) {
            report_request.track_filter.locations = self.arguments.query.locations.join(',');
          }
        }
        if (self.arguments.query.departments && self.arguments.query.departments.length) {
          if (report_request.user_filter) {
            report_request.user_filter.departments = self.arguments.query.departments.join(',');
          }
          if (report_request.manager_filter) {
            report_request.manager_filter.departments = self.arguments.query.departments.join(',');
          }
          if (report_request.content_filter) {
            report_request.content_filter.departments = self.arguments.query.departments.join(',');
          }
          if (report_request.track_filter) {
            report_request.track_filter.departments = self.arguments.query.departments.join(',');
          }
        }
        if (self.arguments.query.teams && self.arguments.query.teams.length) {
          if (report_request.user_filter) {
            report_request.user_filter.teams = self.arguments.query.teams.join(',');
          }
          if (report_request.manager_filter) {
            report_request.manager_filter.teams = self.arguments.query.teams.join(',');
          }
          if (report_request.content_filter) {
            report_request.content_filter.teams = self.arguments.query.teams.join(',');
          }
          if (report_request.track_filter) {
            report_request.track_filter.teams = self.arguments.query.teams.join(',');
          }
        }
        if (self.arguments.query.org_levels && self.arguments.query.org_levels.length) {
          if (report_request.user_filter) {
            report_request.user_filter.org_levels = self.arguments.query.org_levels.join(',');
          }
          if (report_request.manager_filter) {
            report_request.manager_filter.org_levels = self.arguments.query.org_levels.join(',');
          }
          if (report_request.content_filter) {
            report_request.content_filter.org_levels = self.arguments.query.org_levels.join(',');
          }
          if (report_request.track_filter) {
            report_request.track_filter.org_levels = self.arguments.query.org_levels.join(',');
          }
        }
        if (self.arguments.query.grades && self.arguments.query.grades.length) {
          if (report_request.user_filter) {
            report_request.user_filter.grades = self.arguments.query.grades.join(',');
          }
          if (report_request.manager_filter) {
            report_request.manager_filter.grades = self.arguments.query.grades.join(',');
          }
          if (report_request.content_filter) {
            report_request.content_filter.grades = self.arguments.query.grades.join(',');
          }
          if (report_request.track_filter) {
            report_request.track_filter.grades = self.arguments.query.grades.join(',');
          }
        }

        if (self.arguments.query.content && self.arguments.query.content.length) {
          if (report_request.content_filter) {
            report_request.content_filter.content_id = self.arguments.query.content.join(',');
          }
          if (report_request.assignment_filter) {
            report_request.assignment_filter.content_id = self.arguments.query.content.join(',');
          }
          if (report_request.assessment_filter) {
            report_request.assessment_filter.content_id = self.arguments.query.content.join(',');
          }
          if (report_request.workshop_filter) {
            report_request.workshop_filter.content_id = self.arguments.query.content.join(',');
          }
          if (report_request.scorm_filter) {
            report_request.scorm_filter.content_id = self.arguments.query.content.join(',');
          }
        }

        if (self.arguments.query.tracks && self.arguments.query.tracks.length) {
          if (report_request.track_filter) {
            report_request.track_filter.content_id = self.arguments.query.tracks.join(',');
          }
        }
      }

      var number_of_days_in_range = ud.diff(fd, 'days');
      if (report_type === 'track-status' && (!report_request.track_filter || !report_request.track_filter.content_id)) {
        self.showChooseAtLeastOneTrack = true;
        self.loading = false;
        return;
      }
      if (number_of_days_in_range > 366 && report_type === 'assignment-summary' && (!report_request.assignment_filter || !report_request.assignment_filter.content_id)) {
        self.showChooseAtLeastOneContent = true;
        self.loading = false;
        return;
      }

      self.loading = true;
      var reportDetails = {report: report_type};
      if (reportTypeConfig.applyDateRange === true) {
        reportDetails.from = fd.unix();
        reportDetails.until = ud.unix();
      } else {
        Application.messaging.addMessage({type: 'info', text: self.translations['precooked.date_range_info'], duration: 5});
      }
      ReportsService.create(reportDetails, report_request).$promise.then(function(result) {
        if (result.status === 404) {
          Application.messaging.addMessage({type: 'info', text: self.translations['precooked.no_data_for_report'], duration: 5});
          self.loading = false;
          return;
        }
        if (result.status === 422) {
          Application.messaging.addMessage({type: 'info', text: self.translations['precooked.could_not_build'], duration: 5});
          self.loading = false;
          return;
        }
        if (result.length === 0) {
          Application.messaging.addMessage({type: 'info', text: self.translations['precooked.could_not_build'], duration: 5});
          self.loading = false;
          return;
        }
        var csv = report_config.csv(result);

        try {
          var blob = new Blob(['\ufeff' + csv], {type: 'text/csv;charset=utf-8;'});

          if ($window.navigator && $window.navigator.msSaveOrOpenBlob) { // for IE
            //msSaveBlob only available for IE & Edge
            $window.navigator.msSaveBlob(blob, report_config.name + '-report-' + fd.format('YYYYMMDD') + '-' + ud.format('YYYYMMDD') + '.csv');
          } else {

            $window.URL = $window.webkitURL || $window.URL;

            var anchor = $window.document.createElement('a');
            anchor.href = $window.URL.createObjectURL(blob);
            anchor.download = report_config.name + '-report-' + fd.format('YYYYMMDD') + '-' + ud.format('YYYYMMDD') + '.csv';
            $window.document.body.appendChild(anchor); //For FF
            anchor.target = '_blank';
            anchor.click();
            //It's better to remove the elem
            $window.document.body.removeChild(anchor);
          }
          Application.analyticsProvider.trackEvent('report_downloaded', {content: report_config.name, content_type: report_config.reportType});
        } catch (e) {
          console.log('Error downloading:', e);
        }
      }).catch(function(error) {
        console.log('Error calling report resource', error);
        Application.messaging.addMessage({type: 'info', text: self.translations['precooked.could_not_download'], duration: 5});
        self.loading = false;
      }).finally(function() {
        self.loading = false;
      });
    };

    self.editMenu = {
      visible: false,
      activeId: null,
      closeHandler: function() {
        self.editMenu.visible = false;
        self.editMenu.activeId = null;
      },
      clickHandler: function(i) {
        if (self.editMenu.visible) {
          if (self.editMenu.activeId === i) {
            self.editMenu.visible = false;
            self.editMenu.activeId = null;
          } else {
            self.editMenu.activeId = i;
          }
        } else {
          self.editMenu.activeId = i;
          self.editMenu.visible = true;
        }
      }
    };

    $translate([
      'precooked.search_by',
      'precooked.date_range_same',
      'precooked.date_range_info',
      'precooked.no_data_for_report',
      'precooked.could_not_build',
      'precooked.could_not_download',
      'precooked.choose_at_least_one_track',
      'precooked.choose_at_least_one_content'
    ]).then(function(translations) {
      self.translations = translations;
      self.initialize();
    });

  }]);